var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.05 95.05"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.46 19.46a5.42 5.42 0 000-7.67l-10.2-10.2a5.42 5.42 0 00-7.67 0L47.52 29.66 19.46 1.59a5.42 5.42 0 00-7.67 0l-10.2 10.2a5.42 5.42 0 000 7.67l28.07 28.07L1.59 75.59a5.42 5.42 0 000 7.67l10.2 10.2a5.42 5.42 0 007.67 0l28.07-28.07L75.6 93.46a5.42 5.42 0 007.67 0l10.2-10.2a5.42 5.42 0 000-7.67L65.4 47.52l28.07-28.07z",
    fill: "#e54061"
  })));
}
export default SvgRedX;